import React from 'react';
import { Paperclip, Download } from 'lucide-react';
import { fmtDate } from './emailUtils';
import { sanitizeRichHtml } from '../../lib/sanitize';

// Messages of the open thread — memoized (message bodies never change in place).
const EmailMessageList = React.memo(function EmailMessageList({ messages, onDownloadAttachment }) {
  return (
    <div className="flex-1 overflow-y-auto">
      {messages.map((m) => (
        <article key={m.message_id} className="px-6 py-4 border-b border-[#F3F4F8]" data-testid={`email-msg-${m.message_id}`}>
          <header className="flex items-start justify-between gap-2 mb-3">
            <div className="flex-1 min-w-0">
              <div className="text-[13px] font-semibold text-[#1A1B2E] truncate">{m.from}</div>
              <div className="text-[11px] text-[#8E8FA5] truncate">à {m.to || '(inconnu)'}</div>
            </div>
            <div className="text-[11px] text-[#8E8FA5] flex-shrink-0">{fmtDate(m.date_ms)}</div>
          </header>
          {m.body_html ? (
            <div
              className="text-[13px] text-[#1A1B2E] prose prose-sm max-w-none"
              // Le corps vient d'un e-mail recu : HTML d'un tiers, nettoye
              // comme partout ailleurs dans l'application.
              dangerouslySetInnerHTML={{ __html: sanitizeRichHtml(m.body_html) }}
            />
          ) : (
            <pre className="text-[13px] text-[#1A1B2E] whitespace-pre-wrap font-sans">{m.body_text || m.snippet}</pre>
          )}
          {m.attachments && m.attachments.length > 0 && (
            <div className="mt-3 flex flex-wrap gap-2" data-testid={`email-msg-attachments-${m.message_id}`}>
              {m.attachments.map((a) => (
                <button
                  key={a.attachment_id}
                  onClick={() => onDownloadAttachment(m.message_id, a)}
                  className="inline-flex items-center gap-1.5 px-2 py-1 rounded-md border border-[#EFF0F6] bg-[#F6F7FB] text-[11px] text-[#4A4B63] hover:bg-[#EEF2FF] hover:text-[#4F46E5] hover:border-[#C7D2FE]"
                  title="Télécharger"
                >
                  <Paperclip className="w-3 h-3" />
                  <span className="truncate max-w-[200px]">{a.filename}</span>
                  <span className="text-[10px] opacity-70">({Math.round((a.size || 0) / 1024)} Ko)</span>
                  <Download className="w-3 h-3 ml-0.5" />
                </button>
              ))}
            </div>
          )}
        </article>
      ))}
    </div>
  );
});

export default EmailMessageList;
